var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.loaded == false)?_c('waiting'):_vm._e(),(_vm.loaded)?_c('UserList',{attrs:{"items":_vm.items}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }